const sideMenu = [
  {
    id: "purchase_request",
    label: "Purchase Request",
    href: "/app/purchase/request",
    permissions: [1, 2]
  },
  {
    id: "purchase_list",
    label: "Purchase Order",
    href: "/app/purchase",
    permissions: [1, 2]
  },
  {
    id: "userlist",
    label: "User Management",
    href: "/app/users",
    permissions: [1]
  }
];

export default sideMenu;
